import { Record } from '../transit'

const Company = Record({
  _id: null,
  name: '',
  nameSort: '',
  canNotify: false,
  drivingLicenseExpirationEmails: [],
  medicalExamExpirationEmails: [],
  adrExpirationEmails: [],
  trainingExpirationEmails: [],
  drivingLicenseExpirationBody: '',
  medicalExamExpirationBody: '',
  adrExpirationBody: '',
  trainingExpirationBody: '',
  archived: false,
  archivedAt: null,
}, 'company')

export default Company



// WEBPACK FOOTER //
// ./src/common/companies/Company.js